import type {AuthenticatedUser} from "auth/types";
import accountUsersRoutes from "router/routes/accountUsers";
import addressContactsRoutes from "router/routes/addressContacts";
import dashboardRoutes from "router/routes/dashboard";
import developerSettingsRoute from "router/routes/developerSettings";
import insightRoutes from "router/routes/insights";
import messageReport from "router/routes/messageReport";
import messagingRoutes from "router/routes/messaging";
import messagingAccountRoutes from "router/routes/messagingAccount";
import resellersRoutes from "router/routes/resellers";
import topUpRoutes from "router/routes/topUps";
import {ROLE_ADMIN, ROLE_SUPER_ADMIN} from "utils/roles";

const routes = [
  ...dashboardRoutes,
  ...topUpRoutes,
  ...insightRoutes,
  ...messagingRoutes,
  ...addressContactsRoutes,
  ...messagingAccountRoutes,
  ...messageReport,
  ...developerSettingsRoute,
  ...accountUsersRoutes,
  ...resellersRoutes,
];
export default routes;

export const getRoutesForUser = (user: AuthenticatedUser) => {
  if (user.role === ROLE_SUPER_ADMIN) {
    return [
      ...dashboardRoutes,
      ...topUpRoutes,
      ...insightRoutes,
      ...accountUsersRoutes,
      ...messagingAccountRoutes,
      ...messageReport,
      ...resellersRoutes,
      ...messagingRoutes,
      ...addressContactsRoutes,
      ...developerSettingsRoute,
    ];
  }

  if (user.role === ROLE_ADMIN) {
    return [
      ...dashboardRoutes,
      ...resellersRoutes,
      ...messagingRoutes,
      ...messageReport,
      ...messagingAccountRoutes,
      ...addressContactsRoutes,
      ...accountUsersRoutes,
      ...developerSettingsRoute,
    ];
  }

  return routes;
};
